export default __webpack_public_path__ + "static/media/rowers7.88b65087.jpeg";